import { AllocationWeightedShareValue } from 'common/types/valuation';
import { getArrayValue } from 'utilities';

const hasRangeSensitivityFundRow = (weightedShareValue?: AllocationWeightedShareValue) =>
  weightedShareValue?.fund?.id != null;

export const getRangeSensitivityFundRows = (weightedShareValues?: AllocationWeightedShareValue[]) =>
  getArrayValue(weightedShareValues).filter(hasRangeSensitivityFundRow);
